import { Wrench, Hammer, Snowflake, Factory, Thermometer, Building, Wind } from "lucide-react";

const SERVICES = [
  {
    icon: Hammer,
    title: "Instalação de Ar Condicionado",
    desc: "Instalação profissional de splits, multi-splits, cassete, piso-teto e dutos. Todas as marcas e modelos com garantia de serviço.",
    img: "https://images.unsplash.com/photo-1762341123870-d706f257a12e?crop=entropy&cs=srgb&fm=jpg&q=80&w=600",
    size: "large",
  },
  {
    icon: Wrench,
    title: "Manutenção de Ar Condicionado",
    desc: "Manutenção preventiva e corretiva. Limpeza, recarga de gás, troca de peças e diagnóstico completo para todas as marcas.",
    img: "https://images.unsplash.com/photo-1617861648989-76a572012089?crop=entropy&cs=srgb&fm=jpg&q=80&w=600",
    size: "large",
  },
  {
    icon: Snowflake,
    title: "Instalação de Câmaras Frias",
    desc: "Projeto e instalação de câmaras frias para comércios, restaurantes, frigoríficos e indústrias alimentícias.",
    img: "/assets/img/instalacao-camara.jpg",
    size: "normal",
  },
  {
    icon: Snowflake,
    title: "Manutenção de Câmaras Frias",
    desc: "Manutenção preventiva e corretiva de câmaras frias. Troca de compressores, evaporadores e sistemas de controle.",
    img: "/assets/img/manutencao-camara.jpg",
    size: "normal",
  },
  {
    icon: Building,
    title: "Refrigeração Hospitalar",
    desc: "Sistemas de climatização para hospitais, clínicas e laboratórios. Atendemos normas técnicas e regulamentações sanitárias.",
    img: "/assets/img/refrigeracao-hospitalar.jpg",
    size: "normal",
  },
  {
    icon: Factory,
    title: "Sistema de Chiller",
    desc: "Instalação, manutenção e projetos de sistemas chiller para processos industriais e climatização de grandes ambientes.",
    img: "/assets/img/sistema-chiller.jpg",
    size: "normal",
  },
  {
    icon: Wind,
    title: "Torre de Resfriamento",
    desc: "Projetos completos de torres de resfriamento para indústrias. Instalação, manutenção preventiva e corretiva.",
    img: "/assets/img/torre-resfriamento.jpg",
    size: "normal",
  },
];

export default function Services() {
  return (
    <section
      id="servicos"
      data-testid="services-section"
      className="py-24 bg-[#F8FAFC]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-[#E0F2FE] text-[#0E86D4] text-xs font-bold tracking-[0.2em] uppercase px-4 py-1.5 font-['Barlow_Condensed']">
            O que fazemos
          </span>
          <h2
            data-testid="services-title"
            className="mt-4 text-4xl md:text-5xl font-extrabold text-[#0F172A] font-['Barlow_Condensed'] uppercase tracking-tight"
          >
            Nossos Serviços
          </h2>
          <p className="mt-4 text-base md:text-lg text-[#64748B] max-w-2xl mx-auto font-['Manrope']">
            Soluções completas em refrigeração e climatização para residências, comércios, hospitais e indústrias.
          </p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {SERVICES.map((service, idx) => {
            const Icon = service.icon;
            const isLarge = service.size === "large";
            return (
              <div
                key={service.title}
                data-testid={`service-card-${idx}`}
                className={`service-card bg-white rounded-sm overflow-hidden group ${
                  isLarge ? "lg:row-span-1" : ""
                }`}
              >
                {/* Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.img}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3 bg-[#0E86D4] p-2.5 rounded-sm">
                    <Icon className="w-5 h-5 text-white" strokeWidth={2} />
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-[#0F172A] font-['Barlow_Condensed'] uppercase tracking-tight">
                    {service.title}
                  </h3>
                  <p className="mt-2 text-sm text-[#64748B] leading-relaxed font-['Manrope']">
                    {service.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
